import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import TooltipIcon from '../../TooltipIcon';

const FormGroup = ({children, label, name, size, tooltip}) => (
    <div className={classNames('form-group', `col-sm-${size || 12}`)}>
        <label htmlFor={name} className="col-form-label">
            <FormattedMessage {...label} /> {tooltip && <TooltipIcon message={tooltip} />}
        </label>
        <div>
            {children}
        </div>
    </div>
);

export default FormGroup;
